import {z} from 'zod';

export const createJobNameFieldSchema = () => z.string().trim();
